<template>
    <div>
        <shop-head currentPageName="business"></shop-head>
        <div class="content  mt-10 mb-10">
            <div class="container flex-row flex-row-between flex-nowrap ">
                <!-- 左 -->
                <div class="main ">
                    <!-- tabs -->
                    <div class="tabsList">
                        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                            <el-tab-pane :label="$t('供应')" name="first"></el-tab-pane>
                            <el-tab-pane :label="$t('需求')" name="second"></el-tab-pane>
                            <el-tab-pane :label="$t('合作')" name="third"></el-tab-pane>
                            <el-tab-pane :label="$t('招商')" name="fourth"></el-tab-pane>
                            <el-tab-pane :label="$t('其他')" name="fifth"></el-tab-pane>
                        </el-tabs>

                    </div>
                    <!--搜索框  -->
                    <div class="search ">
                        <el-input :placeholder="$t('请输入内容')" v-model="search_data.keyword" style="width: 85%;" clearable
                            @clear="clearData">
                            <template slot="prepend">{{ $t('搜项目') }}</template>
                        </el-input>
                        <el-button class="ml-5" type="danger" @click="handleSearch(1)">{{ $t('搜索') }}</el-button>
                        <div class="prompt mt-10 flex-row-b">
                            <div class="left-content  fx-1">
                                <div class="tabsText fw-b">{{ $t('热门产品') }}:</div>
                                <!-- 数据遍历 -->
                                <div class="item ml-10">
                                    <ul>
                                        <li class="fs-12 " style="color: #747272;" v-for="(item, index) in show_host_p"
                                            :key="index" @click="hots_p_click(item)">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="fs-11 mt-4 " style="width: 8%;" @click="more_b">
                                <a>{{ $t('更多') }}</a>
                                <i v-if="!Ismore" class="el-icon-arrow-down"></i>
                                <i v-else class="el-icon-arrow-up"></i>
                            </div>
                        </div>
                    </div>
                    <!-- 下划线 -->
                    <div class="bor"></div>

                    <!-- 项目分类 -->
                    <div class="classify_title ">
                        <div class="top_title fw-6 fs-15 mt-20 ">
                            {{ $t('项目分类') }}
                        </div>
                        <div class="fs-12  m-10" style="color: #747272;">
                            {{ $t('您还可以选择') }} ：
                        </div>
                        <!-- 内容 -->
                        <div class="m-10 " style="width: 78%;">
                            <el-row :gutter="20" class="flex-wrap">
                                <el-col :span="6" v-for="(item, index) in classify_list" :key="index">
                                    <a @click="click_classify(item.category, index)">
                                        <div class="grid-content bg-purple"
                                            :class="category_active === index ? 'category_active' : ''">
                                            {{ lang == "zh" ? item.category : item.sysDictBO.keyS }} ({{ item.count }})
                                        </div>
                                    </a>
                                </el-col>
                            </el-row>
                        </div>

                    </div>
                    <!-- 主要内容 -->
                    <div class="conten_top ">
                        <div class="mb-10">
                            <a :class="sort_active == 0 ? 'mr-10 fs-15 active_sort' : 'mr-10 fs-15'"
                                @click="sort_proData(0, 'create_time')">{{ $t('最新采购项目') }}</a>
                            <a :class="sort_active == 1 ? 'mr-10 fs-15 active_sort' : 'mr-10 fs-15'"
                                @click="sort_proData(1, 'purchasers')">{{ $t('热门采购项目') }}</a>
                        </div>
                        <div class="bor"></div>
                        <!-- 遍历数据 -->
                        <div class="cont_item mb-20 p-10" v-for="( item, index) in show_dta" :key="index">
                            <div class="item_top fs-18 mt-20 fw-b">{{ item.title }} <span v-if="IsRecent_purchase"
                                    style="color: #c8c8c8;" class="fs-12">{{ $t('近期采购') }}</span></div>
                            <div class="item_con item_r flex-row flex-row-between">
                                <div class="item_l">
                                    <!-- <ul class="m-15">
                                        <li><span class="fw-6 fw-b"> 采购量：</span>5万个/年</li>
                                        <li><span class="fw-6 fw-b">采购量：</span>5万个/年</li>
                                        <li><span class="fw-6 fw-b">采购量：</span>5万个/年</li>
                                    </ul> -->
                                    {{ item.product }}
                                </div>
                                <div class="item_r">
                                    <div class="item_com fw-6">{{ item.companyName }} <i class="el-icon-medal"></i>
                                    </div>
                                    <div class="item_tiem fs-12">{{ item.publish_time }}{{ $t('前发布') }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- 分页 -->
                        <el-pagination background :current-page="currentPage" :page-sizes="[10, 20, 50, 100]"
                            :page-size="search_data.pageSize" layout="total, sizes, prev, pager, next, jumper"
                            :total="total" @size-change="handleChangeSize" @current-change="handleSearch" />
                    </div>
                </div>
                <!-- 右 -->
                <div class="right">
                    <!-- 标题 -->
                    <div class="top_title fw-b fs-19 mt-20 " style="border-left: red 3px solid ;">
                        {{ $t('优质项目推荐') }}
                    </div>
                    <!-- 内容  --> <!-- 遍历数据 -->
                    <div class="cont_item p-10" v-for="(item, index) in hot_listData" :key="index">
                        <div class="item_top fs-16 mt-20 fw-b">{{ item.title }}
                        </div>
                        <div class="item_com fw-6">{{ item.companyName }} <i class="el-icon-medal"></i></div>
                        <div class="item_con item_r flex-col">
                            <div class="item_l fs-13">
                                <!-- <ul class="m-15">
                                    <li><span class="fw-6"> 采购量：</span>5万个/年</li>
                                    <li><span class="fw-6">采购量：</span>5万个/年</li>
                                    <li><span class="fw-6">采购量：</span>5万个/年</li>
                                </ul> -->
                                {{ item.product }}
                            </div>
                            <div class="item_r">
                                <span class="item_tiem fs-12 mr-10">{{ item.publish_time }}{{ $t('前发布') }}</span>
                                <span v-if="IsRecent_purchase" style="color: #c8c8c8;"
                                    class="fs-12">{{ $t('近期采购') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <common-footer></common-footer>
    </div>
</template>
<script>
import shopHead from '../../components/shop/head'
import commonFooter from '../../components/common/footer'
import { searchcompany, searchcompanyAndHot, companyAndHot, business_category } from '../../apis/businees'
export default {
    components: {
        shopHead,
        commonFooter,
    },

    data() {
        return {
            activeName: 'first',
            Ismore: false,
            hots_P: [],
            show_host_p: [],
            classify_list: [],
            sort_active: 0,
            search_data: {
                type: 1,
                sort: 'create_time',
                keyword: '',
                pageSize: 10,
                category: '',
            },
            // 分页
            total: 0,
            currentPage: 1,
            pageSize: 10,
            pageCount: 0,
            show_dta: [],
            show_dta_key: [],
            hot_listData: [],
            category_active: ''

        }
    },
    activated() {
    },

    mounted() {
        this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
        this.getList()
        this.host_fun()
        this.getadata()
        this.b_category()
        this.Hot_type()
    },
    methods: {
        // 供求按钮选择
        handleClick(tab, event) {
            console.log(tab)
            const { index } = tab;
            this.search_data.type = Number(index) + 1
            this.b_category(this.search_data.type)
            this.Hot_type(this.search_data.type)
            this.handleSearch();
        },
        // 更多
        more_b() {
            this.Ismore = !this.Ismore
            this.host_fun()
        },
        // 热门产品处理,一开始需要渲染，对接接口的时候，需要调用
        host_fun() {
            if (!this.Ismore) {
                // 展示10条数据
                this.show_host_p = this.hots_P.slice(0, 5);

            } else {
                // 展示全部
                this.show_host_p = this.hots_P;
            }
        },
        // 排序
        sort_proData(index, type) {
            // 颜色改变
            this.sort_active = index;
            // 改变type
            this.search_data.sort = type
            // 更新数据
            this.handleSearch();
        },
        //获取数据 
        async getList(body = {
            "type": 1,
            "sort": 'create_time',
            "keyword": '',
            "pageSize": 10,
        }) {
            const result = await searchcompany(body);
            this.total = result.data.total
            const temp = result.data.records.map(item => {
                item.IsRecent_purchase = this.IsRecent_purchase(item.createTime) ? true : false;
                item.publish_time = this.Time(item.createTime)
                return item;
            });
            this.show_dta = temp
        },
        // 判断是否一个月之内创建
        IsRecent_purchase(create_time) {
            // 获取当前时间戳
            let currentTimestamp = Date.now();
            // 一个月后的时间戳
            let oneMonthAgoTimestamp = currentTimestamp - (30 * 24 * 60 * 60 * 1000);
            return create_time >= oneMonthAgoTimestamp
        },
        // 离当前时间相隔多少
        Time(create_time) {
            // 获取当前时间戳
            let currentTimestamp = Date.now();
            // 相隔时间
            let timeDifference = currentTimestamp - create_time;

            // 如果时间差小于 60秒，返回秒数
            if (timeDifference < 60 * 1000) {
                const seconds = Math.floor(timeDifference / 1000);
                return `${seconds} 秒`;
            }

            // 如果时间差小于 60分钟，返回分钟数
            else if (timeDifference < 60 * 60 * 1000) {
                const minutes = Math.floor(timeDifference / (60 * 1000));
                return `${minutes} 分钟`;
            }

            // 如果时间差小于 24小时，返回小时数
            else if (timeDifference < 24 * 60 * 60 * 1000) {
                const hours = Math.floor(timeDifference / (60 * 60 * 1000));
                return `${hours} 小时`;
            }

            // 如果时间差超过 24小时，返回天数
            else {
                const days = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
                return `${days} 天`;
            }
        },
        // 获取页面其他数据
        async getadata() {
            // 优质项目
            const hot_listData = await companyAndHot()
            const temp = hot_listData.data.map(item => {
                item.IsRecent_purchase = this.IsRecent_purchase(item.createTime) ? true : false;
                item.publish_time = this.Time(item.createTime)
                return item;
            });
            this.hot_listData = temp
        },
        async b_category(type = 1) {
            // 商品分类
            const { data } = await business_category(type)
            this.classify_list = data
            console.log(this.classify_list)
        },
        async Hot_type(type = 1) {
            const result = await searchcompanyAndHot(type)
            this.hots_P = result.data
            this.show_host_p = this.hots_P.slice(0, 5);
        },
        // 热门商品被点击
        hots_p_click(item) {
            this.search_data.keyword = item
            this.handleSearch();
        },
        // 热门商品被点击
        hots_p_click(item) {
            this.search_data.keyword = item
            this.handleSearch();
        },
        // 点击分类搜索
        click_classify(item, index) {
            if (item !== this.search_data.category) {
                this.search_data.category = item
                this.category_active = index
                this.handleSearch();
            } else {
                this.search_data.category = ''
                this.category_active = ''
                this.handleSearch();
            }
        },
        // 分页
        handleChangeSize(value) {
            this.pageSize = value;
            this.search_data.pageSize = value;
            this.handleSearch();
        },
        // 查询数据
        handleSearch(currentPage = 1) {
            this.currentPage = currentPage;
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.search_data,
                    currentPage,
                },
            });
            this.getList({ ...this.search_data, currentPage });
        },
        // 清除搜索框
        clearData() {
            this.search_data.keyword = ''
            this.handleSearch()
        }


    },

}
</script>
<style lang="scss" scoped>
.content {
    ::v-deep .el-tabs__item.is-active {
        color: white;
        background: #409eff;
    }

    .container {
        background-color: white;
        padding: 20px;

        .main {
            width: 75%;


            .search {
                width: 100%;
                margin: 0 auto;

                .prompt {
                    width: 93%;
                    margin: 20px;

                    .left-content {
                        display: flex;

                        .tabsText {
                            font-size: 14px;
                            color: #747272;
                            cursor: pointer;
                            transition: background-color 0.3s ease;
                        }

                        .item {
                            width: 85%;

                            ul {
                                li {
                                    color: #333;
                                    font-size: 15px;
                                    /* line-height: 50px; */

                                    display: inline-block;
                                    padding-right: 30px;
                                    cursor: pointer;
                                    font-size: 14px;
                                }
                            }
                        }

                    }

                }

            }

            .classify_title {


                .el-row {
                    margin-bottom: 20px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                .el-col {
                    border-radius: 4px;
                    margin-top: 10px;
                }

                .grid-content {

                    border-radius: 4px;
                    min-height: 26px;
                    color: rgb(112, 111, 111);
                    font-size: small;
                }

                .row-bg {
                    padding: 10px 0;
                    background-color: #f9fafc;
                }

                .category_active {
                    color: #ff0c0c;
                }
            }

            .conten_top {

                .active_sort {
                    color: red;
                }

                .cont_item {
                    border-bottom: #f0f0f0 1px solid;

                    .item_top {
                        color: rgb(21, 118, 171);
                    }

                }
            }
        }

        .right {
            width: 23%;

            .cont_item {
                border-bottom: #f0f0f0 1px solid;

                .item_top {
                    color: rgb(21, 118, 171);
                }

                .item_com {
                    color: rgb(148, 155, 160)
                }
            }
        }

        .bor {
            border-bottom: 1px solid #e0e0e0;
        }

        .top_title {
            border-left: #747272 2px solid;
            padding-left: 10px;
            color: #747272;
        }

        .item_con {
            .item_l {
                ul {
                    li {
                        list-style-type: circle;
                        font-size: 13px;
                        color: rgb(148, 155, 160)
                    }
                }
            }

            .item_r {
                .item_com {
                    color: rgb(148, 155, 160)
                }

                .item_tiem {
                    color: rgb(199, 202, 203)
                }
            }
        }
    }

}
</style>
